function Documentation(){
    return (<div>Documentation</div>)
}

export default Documentation;